import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Modal } from './Modal';
import termsRaw from '../../../../../legal/terms-and-conditions.md?raw';
import privacyRaw from '../../../../../legal/privacy-policy.md?raw';
import styles from './LegalModal.module.css';

interface LegalModalProps {
  type: 'terms' | 'privacy';
  isOpen: boolean;
  onClose: () => void;
}

export function LegalModal({ type, isOpen, onClose }: LegalModalProps) {
  const title = type === 'terms' ? 'Terms and Conditions' : 'Privacy Policy';
  const content = type === 'terms' ? termsRaw : privacyRaw;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="xl">
      <div className={styles.scroll}>
        <div className={styles.prose}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>
      </div>
    </Modal>
  );
}
